<template>
    <div>
        <pagamento
            v-show="mostrarPagamento"
            :pagamento="pagamento"
            :pagamentosServicos="obterPagamentosServicos()"
            :despesasServicos="obterDespesasServicos()"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
            :temAcessoDetalharDespesa="$temAcessoView('DESP-GERAIS-REQ-00')"
            :rotaDespesa="'DespesasGerais_Requisitantes_Despesas_Detalhar'"
        >
            <template slot="despesasBotoes">
                <b-button-group class="float-right">
                    <b-button
                        variant="primary"
                        @click="carregarAssociarDespesas()"
                        v-if="mostrarBtnAssociarDespesas"
                        ><i class="fa fa-plus"></i> Associar Despesas</b-button
                    >
                </b-button-group>
            </template>
            <template slot="footer">
                <app-btn-voltar
                    rota="DespesasGerais_Requisitantes_Pagamentos"
                ></app-btn-voltar>
            </template>
        </pagamento>  
        <router-view
            v-if="pagamento"
            :pagamento="pagamento"
            @obterPagamentoAtualizado="obterPagamentoAtualizado()"
        ></router-view>
    </div>
</template>

<script>
import Pagamento from '../../componentes/pagamentos/Pagamento.vue';
import PagamentosServicos from './PagamentosServicos.js'
import { pagamentoStatus } from '@/app/despesasgerais/componentes/pagamentos/PagamentoStatus'
import DespesasServicos from './../despesas/DespesasServicos'

export default {
    data() {
        return {
            pagamento: null
        }
    },
    
    components: {
        Pagamento
    },

    computed: {
        mostrarPagamento() {
            return this.$route.name === 'DespesasGerais_Requisitantes_Pagamentos_Detalhar'
        },

        mostrarBtnAssociarDespesas() {
            return (
                this.pagamento != null &&
                (this.pagamento.status === pagamentoStatus.CRIADO ||
                    this.pagamento.status === pagamentoStatus.REPROVADO) &&
                this.$temAcesso('DESP-GERAIS-REQ-PAG-03')
            )
        }
    },

    methods: {
        obterPagamento() {
            this.$store.dispatch('addRequest')
            PagamentosServicos.obterPorId(this.$route.params.pagamentoId).then(response => {
                if (response) {
                    if (response.success) {
                        this.pagamento = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterPagamentosServicos() {
            return PagamentosServicos
        },

        obterDespesasServicos() {
            return DespesasServicos
        },

        obterPagamentoAtualizado() {
            this.obterPagamento()
            this.$store.dispatch('setRecarregar', true)
        },

        carregarAssociarDespesas() {
            this.$router.push({
                name: 'DespesasGerais_Requisitantes_Pagamentos_AssociarDespesas'
            })
        }
    },

    created() {
        this.obterPagamento()
    }
}
</script>